<template>
  <div>
    <v-toolbar flat color="white">
      <v-layout row wrap>
        <v-flex xs9></v-flex>
        <v-flex xs3>
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Pretraga"
              xs5
              hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>

    <v-layout column>
      <v-flex style="overflow: auto">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          hide-actions
          class="elevation-1"
          :pagination.sync="pagination"
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.align === 'left' ? 'text-xs-left' : 'text-xs-center']"
                @click="changeSort(header.value)"
              >
                <v-icon small v-if="header.sortable !== false"
                      >arrow_upward</v-icon
                    >
                {{ header.text }}
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr>
              <td style="display:none;">{{ props.item.id }}</td>
              <td style="text-align:left;">{{ props.item.name }}</td>
              <td style="text-align:center;">{{ props.item.mark }}</td>
              <td style="text-align:center;" v-if="props.item.lenght !== null">{{ props.item.lenght }} m</td> 
              <td class="justify-center align-content-center pa-2 text-xs-center" v-else
              >{{ "-" }}</td>

              <td style="text-align:center;" v-if="props.item.width !== null">{{ props.item.width }} m</td> 
              <td class="justify-center align-content-center pa-2 text-xs-center" v-else
              >{{ "-" }}</td>

              <td style="text-align:center;" v-if="props.item.height !== null">{{ props.item.height }} m</td> 
              <td class="justify-center align-content-center pa-2 text-xs-center" v-else
              >{{ "-" }}</td> 
              
              <td style="text-align:center;" v-if='props.item.surface !== null'>{{ props.item.surface }} m²</td> 
              <td class="justify-center align-content-center pa-2 text-xs-center" v-else
              >{{ "-" }}</td>

              <td style="text-align:center;" v-if='props.item.volume !== null'>{{ props.item.volume }} m³</td> 
              <td class="justify-center align-content-center pa-2 text-xs-center" v-else
              >{{ "-" }}</td> 
              <td style="text-align:center;">{{ props.item.position }}</td>

              <td class="DataTable__ButtonHolder">
                <img
                  class="DataTable__Button"
                  title="Izmena"
                  src="../assets/icons/zatabele/ico-edit2.svg"
                  alt="ulaz-grozdja"
                  @click="editItem(props.item)"
                >

                  <img
                    class="DataTable__Button"
                    title="Brisanje"
                    src="../assets/icons/zatabele/ico-delete2.svg"
                    alt="delete-item"
                    @click="deleteItem(props.item)"
                  >
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <v-alert slot="no-results" :value="true" color="primary" icon="info">Nema podataka.</v-alert>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="warning"
          >Trazili ste "{{ search }}" ali nema rezultata.</v-alert>
        </v-data-table>
      </v-flex>
    </v-layout>
    <TokenComponent ref="frmtoken"/>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON, scrollToTopBasNaVrh, prevediOperacije2 } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "WareHouseTable",
  props: {
    msg: String
  },
  components: {
      TokenComponent
    },
  data: () => ({
    pagination: {
      sortBy: "name",
      rowsPerPage: 10000000
    },
    search: "",
    headers: [
      // {
      // 	text: "ID",
      // 	align: "left",
      // 	sortable: true,
      // 	value: "id"
      // },
      { text: "Naziv", value: "name", align: "left" },
      { text: "Oznaka", value: "mark", align: "center" },
      { text: "Dužina", value: "lenght", align: "center" },
      { text: "Širina", value: "width", align: "center" },
      { text: "Visina", value: "height", align: "center" },
      { text: "Površina", value: "surface", align: "center" },
      { text: "Zapremina", value: "volume", align: "center" },
      { text: "Redosled na prikazu", value: "position", align: "center" },
      { text: "Funkcije", value: "funkcije", sortable: false }
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      name: "",
      description: ""
    },
    defaultItem: {
      id: 0,
      name: "",
      description: ""
    },
    idWareHouseType: 0
  }),
  methods: {
    deleteSifarnik(id) {
      this.$http
        .delete(this.globalServiceLocation + this.globalPort + "/warehouse/delete/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // // console.log(response);

          this.getAllSifarnik();
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .delete(this.globalServiceLocation + this.globalPort + "/warehouse/delete/" + id, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          // // // console.log(response);

          this.getAllSifarnik();
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllSifarnik() {
      let _this = this;

      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/warehouse/type/" + this.idWareHouseType, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          console.log(response.data);

          _this.items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/warehouse/type/" + this.idWareHouseType, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          _this.items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    changeSort(column) {
      if (column !== "funkcije")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    prevediOperacijeLok(stringLok) {
      let pomStr = prevediOperacije2(stringLok);

      return pomStr;
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);

// scrollToTopBasNaVrh();
serverBus.$emit("scroll_to_top");

      serverBus.$emit("applied_additive_group", item);
    },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
        this.deleteSifarnik(item.id);
    }
  },
  mounted() {
    if (this.idWareHouseType !== 0)
      this.getAllSifarnik();

    serverBus.$on("refresh_additive_group", () => {
      //alert(item.name);
      this.getAllSifarnik();
    });

    serverBus.$on("warehouse_item", (idWareHouseType) => {
      //alert(item.name);

      

      this.idWareHouseType = idWareHouseType;
      this.getAllSifarnik();
    });
  }
};
</script>